import React from 'react';
import { Form, Input, Select } from '@tesla/react-context-form';
import { Component } from 'react';
import { InitialState } from '../../data/initialState';
import { connect } from 'react-redux';

class CN extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cityValues: []
        }
    }

    handleProvinceChange(e) {
        this.props.handleChange(e);
        this.setState({
            cityValues: typeof this.props.cityList[e.value] !== "undefined" ? this.props.cityList[e.value] : null
        });
    }

    render() {
        const { props } = this;
        const { provinceList, cityList, email, firstName, lastName, phone, zip, showECheckbox, values, form, province, cities } = props;
        const { cityValues } = this.state;
        const Tesla = window.Tesla || {};

        return (
            <div className="form-container en-us">
                <Form initialValues={values}>
                    <div className="tds-flex tds-layout-flex--two_columns">
                        <div className={"tds-flex-item " + firstName.class}>
                            <Input name="firstName" label={form.firstName} onChange={props.handleChange} id="edit-firstname-td" />
                            <p className="tds-form-item-feedback">{firstName.msg}</p>
                        </div>
                        <div className={"tds-flex-item " + lastName.class}>
                            <Input name="lastName" label={form.lastName} onChange={props.handleChange} id="edit-lastname-td" />
                            <p className="tds-form-item-feedback">{lastName.msg}</p>
                        </div>
                    </div>
                    <div className={"item-container " + email.class}>
                        <Input name="email" label={form.email} onChange={props.handleChange} id="edit-usermail-td" />
                        <p className="tds-form-item-feedback">{email.msg}</p>
                    </div>
                    <div className={"item-container " + phone.class}>
                        <Input name="phone" label={form.phoneNr} onChange={props.handleChange} id="edit-phonenumber-td" />
                        <p className="tds-form-item-feedback">{phone.msg}</p>
                    </div>
                    {provinceList == null ? null :
                        <div className={"item-container " + province.class}>
                            <Select name="province" label={form.province} onChange={this.handleProvinceChange.bind(this)} autoscript="edit-provinces-td">
                                <option value="">省份</option>
                                {
                                    Object.keys(provinceList).map( (key, data) => 
                                        <option key={key} value={key}>{provinceList[key]}</option>
                                    )
                                }
                            </Select>
                            <p className="tds-form-item-feedback">{province.msg}</p>
                        </div>
                    }
                    {provinceList == null ? null :
                        <div className={"item-container " + cities.class}>
                            <Select name="cities" label={form.cities} onChange={props.handleChange} autoscript="edit-cities-td">
                                <option value="">市（区）</option>
                                {
                                    Object.keys(cityValues).map( (key, data) => 
                                        <option key={key} value={cityValues[key]}>{cityValues[key]}</option>
                                    )
                                }
                            </Select>
                            <p className="tds-form-item-feedback">{cities.msg}</p>
                        </div>
                    }
                      <div className="tds-form-item">
                        <fieldset className="tds-form-fieldset" onChange={props.handleChange}>
                          <div className="tds-checkboxes">
                            {showECheckbox ?
                                <div className="tds-checkbox">    
                                  <input className="tds-checkbox-input" name="einterest" type="checkbox" id="interest-solar-powerwall" defaultChecked />
                                  <label className="tds-label tds-label--checkbox" htmlFor="interest-solar-powerwall">      
                                    <span className="tds-label-title">{form.interestedSolarPowerwall}</span>      
                                  </label>  
                                </div>
                            : null}
                            <div className="tds-checkbox">    
                              <input className="tds-checkbox-input" name="getUpdates" type="checkbox" id="get-updates" defaultChecked={values.getUpdates} />    
                              <label className="tds-label tds-label--checkbox" htmlFor="get-updates">      
                                <span className="tds-label-title">{form.getUpdates}</span>      
                              </label>  
                            </div>
                          </div>
                        </fieldset> 
                      </div>
                      <p>{form.disclaimer2}</p>
                </Form>
            </div>
        )
    }
}

CN.defaultProps = InitialState().formsSection

// Map Redux state to component props
function mapStateToProps(state) {
    var _state = state;

    return {
        firstName: _state.formsSection.validation.firstName,
        email: _state.formsSection.validation.email,
        lastName: _state.formsSection.validation.lastName,
        phone: _state.formsSection.validation.phone,
        zip: _state.formsSection.validation.zip,
        province: _state.formsSection.validation.province,
        cities: _state.formsSection.validation.cities
    }
}

const CNForm = connect(
    mapStateToProps
)(CN)

export default CNForm
